// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../slices/userSlice';

const store = configureStore({
  reducer: {
    user: userReducer, // Connect userSlice to the store
  },
});

export default store;
